import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { animation, modalStyle } from '@/styles/style';
import zIndex from '@/styles/zIndex';

import { Flex } from '../base';
import Portal from '../Portal/Portal';

type Props = {
  children: ReactNode;
  style?: CSSProperties;
};

const ContentPreview = (props: Props) => {
  return (
    <Portal id="preview-layer">
      <Style style={props.style}>{props.children}</Style>
    </Portal>
  );
};

const Style = styled(Flex)`
  pointer-events: none;
  position: fixed;
  ${modalStyle};
  backdrop-filter: blur(12px);
  border-radius: 16px;
  z-index: ${zIndex.preview};
  animation: ${animation.fadeIn} 200ms;
`;

export default ContentPreview;
